const ResizeIcon = ({ height }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 20L20 20L20 10" stroke="#222222" />
      <path d="M12 17L17 17L17 12" stroke="#222222" />
    </svg>
  );
};

export default ResizeIcon;
